import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ColorEnum } from "@/modules/vue/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'Status',
  props: {
    value: null,
    colors: null,
    color: null
  },
  setup(__props) {
    const props = __props;
    const colorMap = {
      [ColorEnum.Slate]: 'bg-slate-100 text-slate-700',
      [ColorEnum.Gray]: 'bg-gray-100 text-gray-700',
      [ColorEnum.Zinc]: 'bg-zinc-100 text-zinc-700',
      [ColorEnum.Neutral]: 'bg-neutral-100 text-neutral-700',
      [ColorEnum.Stone]: 'bg-stone-100 text-stone-700',
      [ColorEnum.Red]: 'bg-red-100 text-red-700',
      [ColorEnum.Orange]: 'bg-orange-100 text-orange-700',
      [ColorEnum.Amber]: 'bg-amber-100 text-amber-700',
      [ColorEnum.Yellow]: 'bg-yellow-100 text-yellow-700',
      [ColorEnum.Lime]: 'bg-lime-100 text-lime-700',
      [ColorEnum.Green]: 'bg-green-100 text-green-700',
      [ColorEnum.Emerald]: 'bg-emerald-100 text-emerald-700',
      [ColorEnum.Teal]: 'bg-teal-100 text-teal-700',
      [ColorEnum.Cyan]: 'bg-cyan-100 text-cyan-700',
      [ColorEnum.Sky]: 'bg-sky-100 text-sky-700',
      [ColorEnum.Blue]: 'bg-blue-100 text-blue-700',
      [ColorEnum.Indigo]: 'bg-indigo-100 text-indigo-700',
      [ColorEnum.Violet]: 'bg-violet-100 text-violet-700',
      [ColorEnum.Purple]: 'bg-purple-100 text-purple-700',
      [ColorEnum.Fuchsia]: 'bg-fuchsia-100 text-fuchsia-700',
      [ColorEnum.Pink]: 'bg-pink-100 text-pink-700',
      [ColorEnum.Rose]: 'bg-rose-100 text-rose-700'
    };
    const classes = computed(() => {
      if (props.color) {
        return colorMap[props.color];
      }
      if (props.colors) {
        return colorMap[props.colors[props.value]];
      }
      throw 'Need to call either color or colors props.';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["px-2 text-center uppercase font-mono rounded", _unref(classes)])
      }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.value), 1)])], 2);
    };
  }
});